import { theme } from './theme';
import { Breakpoint } from './types';

export function isBreakpoint(breakpoint: Breakpoint) {
  return window.matchMedia(`(min-width: ${theme.breakpoints[breakpoint]})`)
    .matches;
}
